<template>
    <div class="bank_box">
      <a v-for="pspObj in cellValue" :key="pspObj.pspTlId" 
       class="link_element"
        
       @click.prevent="handleClick(pspObj, $event)">
       
        {{ formatDisplayText(pspObj.display) }}
      </a>
    </div>
  </template>
  
  <script>
  import { EventBus } from '@/eventBus.js';
  export default {
    
    methods: {
        handleClick(pspObj,event){
            //const pspTlId = event.currentTarget.getAttribute('data-bank');
            const rowData = this.params.data;
            pspObj.bk_name=rowData.bk_name
            EventBus.$emit('psp-clicked', pspObj);
            
             
           // console.log('brokerBanks Clicked bank ID:', pspTlId);
        }, 

      
      formatDisplayText(linkAddress) {
      
       // const url = new URL(linkAddress);
        //const shortenedLink = url.hostname.substring(0, 5);
        return linkAddress;
        //return `${shortenedLink}`;
      },
      doNothing: function(){
            return false;
        },
       
        copyToClipBoard: function(value){
            let that = this;
            let text = value;
            let textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                if(document.execCommand('copy'))
                    that.openAlert('success','','copied to clipboard');
            } catch(e) {
                this.doNothing()
                //console.log('Oops, unable to copy');
            }
            document.body.removeChild(textArea);
        },

      



        openAlert(color,title,text) {
            let colorAlert = color;
            this.$vs.notify({
                title: title,
                text: text,
                color: colorAlert
            })
        },
    },
   
    computed: {
        cellValue() {
            //console.log(this.params.value)
            return JSON.parse(this.params.value);
           
        }
    }, 
    
    mounted() { 
        
        
       // console.log('Received cell value:', this.cellValue);
    },

  };
  
  </script>
  
  <style>
  .link_element{
    border: 1px solid;
    padding: 5px 10px;
  margin-left: 10px;
  margin-right: 10px;
  color: rgb(115, 103, 240);
  
  }

  
  
  </style>